import { render, staticRenderFns } from "./GalleryItem.vue?vue&type=template&id=e57187f2&"
import script from "./GalleryItem.vue?vue&type=script&lang=js&"
export * from "./GalleryItem.vue?vue&type=script&lang=js&"
import style0 from "./GalleryItem.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports